'use strict';

exports.__esModule = true;
exports.LOADABLE = exports.COMPONENT_IDS = undefined;

var _createSymbol = require('./utils/createSymbol');

var _createSymbol2 = _interopRequireDefault(_createSymbol);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COMPONENT_IDS = exports.COMPONENT_IDS = '__LOADABLE_COMPONENT_IDS__';
var LOADABLE = exports.LOADABLE = (0, _createSymbol2.default)('loadable');


//////////////////
// WEBPACK FOOTER
// ./node_modules/loadable-components/constants.js
// module id = 8
// module chunks = 3